<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<!-- <ng-container *ngIf="cardNumberConflictExists">


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;">Amano One Matching Card Number Found</span></div>
  
  <div style="margin-left:30px;margin-top:0px;">
    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
       Card Number <span style="font-weight:bold;color:red;">{{accessHolder.credentials[0].credentialReference}}</span> already exists in the Amano One PARCS system.  Please review the information below and click Overwrite to update the Parker information in the Amano One profile.
    </div>

    <div class="row" style="margin-left:20px;margin-right:20px;">
        <div class="col-4" >{{accessHolder.contactInfo.lastName}}, {{accessHolder.contactInfo.firstName}}</div>

        @if(accessHolder.contactInfo.emails.length > 0) {
        <div class="col-4">{{accessHolder.contactInfo.emails[0].emailAddress}}</div>
          @if(accessHolder.company != null ||  accessHolder.company != '') {
            <div class="col-4">{{accessHolder.company}}x</div>}
          @else{
            <div class="col-4">No Company on File </div>
          }
        } @else {
        <div class="col-4">No Email on File</div>
          @if(accessHolder.company === null || accessHolder.company === '') {
            <div class="col-4">No Company on File </div>
          }
          @else{
            <div class="col-4">{{accessHolder.company}}</div>
          }
        }

        
        <div class="col-4">Start Date: {{accessHolder.startDate | date}}</div>
        <div class="col-4">End Date: {{accessHolder.endDate | date}}</div>
        <div class="col-4"></div>

        @if(accessHolder.vehicles.length > 0) {
          <div class="col-4">{{accessHolder.vehicles[0].vehicleYear}} {{accessHolder.vehicles[0].make}}</div>
          <div class="col-4">{{accessHolder.vehicles[0].model}}</div>
          <div class="col-4">License: {{accessHolder.vehicles[0].licenseNumber}}</div>
        }
        @else {
          <div class="col-6">No Vehicle(s) on File</div>
          <div class="col-6"></div>
        }
        
    </div>
  
<div style="margin-top:20px;margin-left:5px;">
  <span style="font-size:18px;font-weight: bold;" >Select Amano One Access Group</span>
</div>
    <div style="height:100px;overflow-y: hidden;overflow-x: hidden;">
    <div class="row" style="margin-top:10px;margin-left:5px;">
        <div class="col-11" style="padding:10px;height:95%;">
            <div style="margin-left:10px;">
              <mat-form-field style="width:400px;">
                <mat-select [(ngModel)]="selectedSourceAccessGroup">
                    @if(accessHolderGroups.length === 0){
                        <mat-option value="" disabled="true"><strong>Loading Access Groups...</strong></mat-option>
                    }
                    @else{
                      <mat-option value=""><strong>Select PARC Access Group</strong></mat-option>
                      @for (group of accessHolderGroups; track group) {
                        <mat-option [value]="group.accessGroupID">{{group.name}}</mat-option>
                      }
                    }
                </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row">
         
        <div class="col-9" style="margin-top:0px;">
            <div style="margin-top:20px;margin-right:20px;">
            <span style="font-size:14px;color:red;">An Amano One profile is already using this card number: <strong>{{data.cardNumber}}</strong>.  Clicking Submit/Overwrite will replace this Parker's values on the Amano One profile.</span>
            </div>
        </div>
        </div>
    </div>
</div>
<div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:45px;position:relative;">

<div mat-dialog-actions align="end" style="position:relative;top: -10px;">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  @if(selectedSourceAccessGroup !== '') {
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial style="background-color:#003087 !important;color:white !important" (click)="onOverwriteParkerAccessGroup()">Submit/Overwrite</button>
  }
  @else{
    <button mat-button  cdkFocusInitial style="background-color:lightgray !important;color:darkgray !important" disabled="true">Submit/Overwrite</button>
  }
  
</div>
</div>
</ng-container> -->



<!-- <ng-container *ngIf="!cardNumberConflictExists"> -->
    <!-- <div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;">Amano One Matching Card Number Found</span></div> -->
  
<div style="margin-top:20px;margin-left:25px;">
  <span style="font-size:18px;font-weight: bold;" >Select Amano One Access Group</span>
</div>
    <div style="height:680px;overflow-y: hidden;overflow-x: hidden;">
    <div class="row" style="margin-top:10px;margin-left:25px;">
        <div class="col-11" style="padding:10px;height:95%;">
            <div style="margin-left:5px;">
                <mat-form-field style="width:600px;">
                <mat-select [(ngModel)]="selectedSourceAccessGroup" (ngModelChange)="evaluateCreateAmanoDataReadyToSave()">
                    @if(accessHolderGroups.length === 0){
                        <mat-option value="" disabled="true"><strong>Loading Access Groups...</strong></mat-option>
                    }
                    @else{
                      <mat-option value=""><strong>Select PARC Access Group</strong></mat-option>
                      @for (group of accessHolderGroups; track group) {
                        <mat-option [value]="group.accessGroupID">{{group.name}}</mat-option>
                      }
                    }
                </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    

    @if(this.data.cardNumber != null && this.data.cardNumber != '')
    {
     <div class="row" style="margin-top:10px;margin-left:20px;">
        <div class="col-11" style="padding:10px;height:95%;">
            <div style="margin-left:0px;">
              <mat-form-field appearance="fill" style="width:600px;color:gray;margin-left:10px;">
                <mat-label>Select Credential Type ({{credentialTypesList.length}})*</mat-label>
                <mat-select [(ngModel)]="credentialTypeId" (ngModelChange)="onCredentialTypeChange($event)" [disabled]="!createAmanoOneProfile">
                    @if(credentialTypesList.length === 0) {
                        <mat-option value="">Loading Credential Types...</mat-option>
                    }
                    @else {
                        <mat-option value="">Select Credential Type</mat-option>
                        <mat-option *ngFor="let type of credentialTypesList" [value]="type.credentialTypeId" >
                        {{type.credentialTypeName}} 
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            </div>
        </div>
    </div>

     <div class="row" style="margin-top:10px;margin-left:25px;">
       <div class="col-11" style="padding:10px;height:95%;">
        @if(credentialTypeId == ''){
            <div style="margin-top:20px;">
                    <span>&uarr; Select Credential Type</span>
            </div>
        }
        @else{
            @if(credentialTypeNoSystemCodeFlag){
                <div style="margin-top:20px;">
                    <span>No Credential System Code required for this Credential Type</span>
                </div>
            }
            @else {
                <mat-form-field appearance="fill" style="width:605px;color:gray;">
                <mat-label>Select Credential Code  ({{credentialCodesList.length}})*</mat-label>
                        <mat-select (selectionChange)="onCredentialCodeChange($event)" [(ngModel)]="credentialCodeSettingValue" [disabled]="!createAmanoOneProfile">
                            <mat-option value="">Select Credential Code</mat-option>
                            <mat-option *ngFor="let code of credentialCodesList" [value]="code.credentialCode">
                            {{code.credentialCode}} 
                            </mat-option>
                        </mat-select>
                </mat-form-field>
            }
        }
        </div>
    </div>
    }
    @else 
    {
      <div class="row" style="margin-top:20px;margin-left:25px;">
        <div class="col-11" style="padding:10px;height:95%;">
            <div style="margin-left:5px;">
                Credential Types and Credential System Codes are disabled until a Card Number is entered for the Parker.
            </div>
        </div>
      </div>  
    }
    </div>
<div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:25px;position:relative;">

<div mat-dialog-actions align="end" style="position:relative;top: -20px;">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  @if(submitButtonDisabled) {
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial style="background-color:lightgray !important;color:darkgray !important" disabled="true">Submit</button>
  }
  @else{
    <button mat-button [mat-dialog-close]="newAmanoOneAddExistingParkerRequest" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Submit</button>
  }
</div>
</div>
<!-- </ng-container> -->


